import styled from "styled-components";
import { Link } from "react-router-dom";

// Design System
import { Colors } from "../../styles/DesignSystem";

export const HeaderContainer = styled.header`
    width: 100%;
    z-index: 9;
    background: transparent;
    padding: 1.5rem 5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (min-width: 320px) and (max-width: 480px){
        padding: 2rem;    
        position: relative;
        z-index: 999;
    }

    @media screen and (min-width: 481px) and (max-width: 768px){
        padding: 2rem;
    }

    @media screen and (min-width: 769px) and (max-width: 1024px){
        
    }

    @media screen and (min-width: 1025px) and (max-width: 1200px){
        
    }

    @media screen and (min-width: 1201px){
        
    }
`;

export const LogoHeader = styled.figure`

    img{
        width: 75%;
    }
    
    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 50%;

        img{
            width: 100%;
        }
    }

    @media screen and (min-width: 481px) and (max-width: 768px){
        width: 50%;

        img{
            width: 100%;
        }
    }

`;

export const MenuIcon = styled.button`
  position: absolute;
  top: 6%;
  right: 2rem;
  display: none;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;

  &:focus {
    outline: none;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background: ${Colors.brown};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
    }

    :nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }

    @media screen and (min-width: 320px) and (max-width: 480px){
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        top: 35%;
    }

    @media screen and (min-width: 481px) and (max-width: 768px){
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        top: 35%;
    }
`;

export const NavContainer = styled.nav`
    display: flex;
    justify-content: center;
    align-items: center;

    button{
        margin-top: 15px;
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        display: none;
    }

    @media screen and (min-width: 481px) and (max-width: 768px){
        display: none;
    }
`;

export const NavMenu = styled.ul`
    display: flex;
    justify-content: center;
    align-items: flex-end;

    margin-right: 2.5rem;
`;

export const NavItem = styled.li`
    position: relative;
    list-style: none;
    font: 1rem/1 'Varela Round', arial, sans-serif;
    color: ${Colors.brown};
    margin: 0 1rem;
    padding: .5rem 1.2rem;
    border-radius: 25px;

    transition: all ease-in-out .5ms;

    &.active,
    &:hover{
        background-color: ${Colors.lighBrown};
    }

    &:hover{
        ul, li ul{
            display: block;
            &:hover{
                display: block;
            }
        }
    }

    @media screen and (min-width: 769px) and (max-width: 1024px){
        font-size: 1rem;
    }

    @media screen and (min-width: 1025px) and (max-width: 1200px){
        font-size: 1rem;
    }

`;

export const SubNav = styled.ul`
    width: 175px;
    position: absolute;
    z-index: 99;
    display: none;
    left: -32%;

    padding: 15%;
    margin-top: 10%;

    background-color: ${Colors.white};
    border-radius: 20px;
    -webkit-box-shadow: -3px -1px 19px -6px rgba(243,106,16,0.17); 
    box-shadow: -3px -1px 19px -6px rgba(243,106,16,0.17);

    svg{
        fill: ${Colors.lighBrown};

        position: absolute;
        top: -2%;
        left: 45%;
    }

    &:hover{
        display: block;
    }
`;

export const SubItem = styled.li`
    padding: .75rem 0;
    position: relative;

    &:hover,
    .active{
        color: ${Colors.orange};

        &::before{
            content: '';
            height: 75%;
            width: 3px;
            border-radius: 15px;
            background-color: ${Colors.orange};

            position: absolute;
            top: 10%;
            left: -5%;
        }
    }
`;

export const NavLink = styled(Link)`
    cursor: pointer;
`;

export const SocialIcons = styled.aside`
    display: flex;
    align-items: center;
    background: ${Colors.gradient};

    cursor: pointer;
    padding: .35rem 1.5rem ;
    border-radius: 25px;

    a{
        width: 15px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg{
            width: 100%;
            fill: ${Colors.white};
        }

        &:nth-child(2){
            margin: 0 1rem;
        }

        &:first-child{
            svg{
                width: 8px;
            }
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        display: none;
    }
`;